import * as React from "react";

import * as Media from "react-media";

interface FooterProps {
	style?: any;
	onInfoClick: any;
}

interface FooterNavItemProps {
	link: string;
	title: string;
	isMobile: boolean;
}

const FooterNavItem = (props: FooterNavItemProps) => (
	<a className="nav-item" href={props.link} target="_blank" style={{
		marginLeft: props.isMobile ? "0px" : "40px",
		marginTop: props.isMobile ? "7px" : "0px",
		fontFamily: "Inter RG",
		fontSize: 12,
		color: "#868E96",
		cursor: "pointer",
	}}>{props.title}</a>
)

const Footer = (props: FooterProps) => (
	<Media query={{ maxWidth: 600 }}>
		{isMobile => (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					marginTop: "auto",
					padding: isMobile ? "20px 30px" : "40px 30px",
					color: "rgb(24, 114, 224)",
					backgroundColor: "#fff",
					...(props.style || {}),
				}}
			>

				<div
					style={{
						display: "flex",
						alignItems: "center",
						flexDirection: isMobile ? "column" : "row",
						marginLeft: "auto",
						marginRight: isMobile ? "auto" : 0
					}}
				>
					<span
						style={{
							fontFamily: "Inter RG",
							fontSize: "12px",
							color: "#868E96",
						}}
					>
						&copy; Copyright {new Date().getFullYear()} Vatom, Inc.
					</span>
					<FooterNavItem title="Privacy Policy" link="https://www.vatom.com/privacy-policy" isMobile={isMobile}/>
					<FooterNavItem title="Terms of Service" link="https://www.vatom.com/terms" isMobile={isMobile}/>
					<FooterNavItem title="Support" link="https://www.vatom.com/support/" isMobile={isMobile}/>
				</div>
			</div>
		)}
	
	</Media>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx